import Question from '../../../components/Question/Question';
import QuizFeedback from './QuizFeedback';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// todo: change onClick to link when migrating to UIComponent v2's (using linkComponent)
const QuizQuestion = ({
  answers,
  correctAnswer,
  feedbackText,
  hasAnswered,
  id,
  image,
  imageAlt,
  onSelectAnswer,
  onTryAgainClick,
  selectedAnswerIds,
  title,
  type
}) => {
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    paddingBlockStart: "500",
    children: [/*#__PURE__*/_jsx("h2", {
      "data-test-id": "question-name",
      children: /*#__PURE__*/_jsx("div", {
        style: {
          whiteSpace: 'pre-line'
        },
        children: title
      })
    }), hasAnswered ? /*#__PURE__*/_jsx(QuizFeedback, {
      correctAnswer: correctAnswer,
      onTryAgainClick: onTryAgainClick,
      children: feedbackText
    }) : /*#__PURE__*/_jsx(Question, {
      answers: answers,
      id: id,
      image: image,
      imageAlt: imageAlt,
      onSelectAnswer: onSelectAnswer,
      selectedAnswerIds: selectedAnswerIds,
      type: type
    })]
  });
};
export default QuizQuestion;